import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { logger } from '../utility/logger'

export default defineNuxtRouteMiddleware((to) => {
  logger('mapsUrlRedirect4 middleware', to.fullPath)
  const { $isDesktop } = useNuxtApp()
  logger('mapsUrlRedirect2 middleware', $isDesktop, to.fullPath)
  if ($isDesktop) {
    const pageName = to.name?.toString() || to.path
    if (pageName === 'maps') {
      logger('mapsUrlRedirect middleware', to.fullPath)
      const url = to.fullPath.replace('/maps/', '/search/')
      return navigateTo(url, { redirectCode: 302 })
    }
  }
})
